import get from 'lodash/get';

export function generateHomeHref(props) {
  const base64Params = get(props, 'params.base64Params');
  return `/reservation/${base64Params}`;
}

export function generateCancelReservationHref(props) {
  const base64Params = get(props, 'params.base64Params');
  return `/reservation/${base64Params}/cancelReservation`;
}

export function generateAddToCalendarHref(props) {
  const base64Params = get(props, 'params.base64Params');
  return `/reservation/${base64Params}/addToCalendar`;
}

export function getTitle(i18n, status) {
  if (status === 'canceledByRestaurant') {
    return i18n.get('reservations_email_customer_reservationinfo_title_canceledByRestaurant', 'Your Reservation Has Been Declined');
  } else if (status === 'canceledByCustomer') {
    return i18n.get('reservations_email_customer_reservationinfo_title_canceledByCustomer', 'You’ve Cancelled Your Reservation');
  } else if (status === 'accepted') {
    return i18n.get('reservations_email_customer_reservationinfo_title_accepted', 'Your Reservation is Confirmed!');
  } else if (status === 'new') {
    return i18n.get('reservations_email_customer_reservationinfo_title_new', 'We are Processing Your Reservation');
  }

  return i18n.get('modify_reservation_title', 'Modify Reservation');
}

export function getSubTitle(i18n, status) {
  if (status === 'canceledByRestaurant') {
    return i18n.get('reservations_email_customer_reservationinfo_subtitle_canceledByRestaurant', 'Unfortunately, we had to decline your reservation.');
  } else if (status === 'canceledByCustomer') {
    return i18n.get('reservations_email_customer_reservationinfo_subtitle_canceledByCustomer', 'Plans change - we get it! Thanks for letting us know. You’re always welcome to book with us for another time.');
  } else if (status === 'new') {
    return i18n.get('reservations_app_success_description_pending', 'We received your reservation and will email or text you to confirm.');
  } else if (status === 'accepted') {
    return i18n.get('reservations_email_customer_reservationinfo_subtitle_accepted', 'Everything is all set, we’ll see you soon!');
  }

  return i18n.get('modify_reservation_sub_title', 'Thank you! You’ll find your reservation details below.');
}

export default {
  generateHomeHref,
  generateCancelReservationHref,
  generateAddToCalendarHref,
  getTitle,
  getSubTitle
};



// WEBPACK FOOTER //
// ./utils/reservationUtils.js